import { CSSProperties } from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import Badge from "../../../components/Badge";
import { BadgeVariant } from "../../../components/Badge/types";
import { TableData } from "../../../components/Table/types";
import { PipelineImport } from "../../../api/types";
import { capitalize } from "../../../utils/capitalize";
import { timeToText } from "../../../utils/time";
import { typedSxMap } from "../../../utils/typedSxMap";

const styles = typedSxMap({
  tooltipWrapper: {
    position: "absolute",
    transform: "translateX(-50%)",
    backgroundColor: "var(--color-background-modal)",
    padding: "var(--m-xxs) var(--m-xs)",
    borderRadius: "var(--border-radius)",
    marginTop: "var(--m-xs)",
    boxShadow: "0 0 0 1px var(--color-border), 0 5px 15px rgba(0, 0, 0, 0.2)",
    maxWidth: "300px",
    zIndex: 1000,
    color: "var(--color-text)",
  },
});

export function pipelineImportsTable(imports: PipelineImport[] = []): TableData {
  return imports.map((importItem) => {
    return {
      id: importItem.id,
      Name: importItem.name,
      Schema: importItem.schema?.name || "",
      Rows: importItem.dst_num_rows,
      Errors: importItem.dst_num_error_rows,
      Created: timeToText(importItem.created_at),
      Status: {
        raw: importItem.status,
        content: getStatusBadge(importItem.status, importItem.error as string),
      },
      // _actions: {
      //   raw: importItem.id,
      //   content:
      //     importItem.status === "review" || importItem.status === "importing" || importItem.status === "complete" ? (
      //       <DownloadImport importItem={importItem} />
      //     ) : (
      //       <></>
      //     ),
      // },
    };
  });
}

export function getStatusBadge(status?: string, tooltip?: string): React.ReactElement {
  if (!status) {
    return <></>;
  }
  let variant: BadgeVariant = "neutral";
  switch (status) {
    case "uploading":
    case "processing":
      // TODO: Need a more status badge variants
      break;
    case "review":
      variant = "highlight";
      status = "Review";
      break;
    case "importing":
      // variant = "warning";
      break;
    case "complete":
      variant = "success";
      break;
    case "no_match":
      variant = "highlight";
      status = "No Match";
      break;
    case "fail":
      variant = "error";
      status = "Failed";
      break;
  }
  const badgeStyles: CSSProperties = { textWrap: "nowrap", marginRight: "8px", minWidth: "80px", textAlign: "center" };
  return tooltip ? (
    <Box style={{ position: "relative", display: "flex" }}>
      <Tooltip label={tooltip} shouldWrapChildren={true} aria-label={status} sx={styles.tooltipWrapper}>
        <Badge variants={[variant]} style={badgeStyles}>
          {capitalize(status)}
        </Badge>
      </Tooltip>
    </Box>
  ) : (
    <Badge style={badgeStyles} variants={[variant]}>
      {capitalize(status)}
    </Badge>
  );
}
